export default "__VITE_ASSET__BL3kEEP1__"